module.exports = __webpack_public_path__ + "img/whatsapp.f906cc48.jpg";